/**
 * Renders a `position: fixed` overlay into <body>, out of whatever laid it out.
 *
 * WHY THIS EXISTS — a fixed overlay is only fixed to the VIEWPORT while no
 * ancestor establishes a containing block for it. `transform`, `filter`,
 * `perspective`, `will-change`, `backdrop-filter`, `contain: layout|paint` and
 * `container-type` all do, and any one of them silently re-anchors a fixed
 * child to that ancestor's box instead.
 *
 * react-grid-layout positions every account-board cell with
 * `transform: translate(...)` (useCSSTransforms defaults to true, and even the
 * identity `matrix(1,0,0,1,0,0)` counts). So a modal rendered inside a widget —
 * the transactions drilldown under a chart, contact detail under the org chart —
 * was laying itself out inside a ~400px grid cell rather than over the page.
 * Measured on the board harness before this landed: a 100%×100% fixed probe
 * inside `.abw__body` reported the cell's exact rect, not the viewport's.
 *
 * Portalling to <body> is the fix, and it is also the precondition for putting
 * `container-type: inline-size` on `.abw__body` — that adds a SECOND containing
 * block for the same reason, so without this every board modal would break
 * again the moment widgets became container-aware.
 *
 * React portals keep the React tree intact: context, state and event bubbling
 * all still flow through the component that rendered the overlay. Only the DOM
 * position moves.
 */

import { createPortal } from 'react-dom';

export default function OverlayPortal({ children }) {
  if (typeof document === 'undefined') return null;
  return createPortal(children, document.body);
}
